import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 bg-white border-t border-gray-100" data-id="element-89">
      <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl p-8 border border-gray-200 flex flex-col md:flex-row items-center gap-8" data-id="element-90">
        <div className="flex-shrink-0" data-id="element-91">
          <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-md border border-purple-100" data-id="element-92">
            <ShieldCheck className="w-12 h-12 text-purple-600" data-id="element-93" />
          </div>
        </div>
        <div className="text-center md:text-left" data-id="element-94">
          <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-95">
            Garantía sin complicaciones
          </h3>
          <p className="text-gray-600 leading-relaxed" data-id="element-96">
            Prueba el material durante 7 días. Si sientes que no ordena tus
            sesiones, te devolvemos el 100% de tu dinero. Sin preguntas. Sin
            letra pequeña.
          </p>
        </div>
      </div>
    </section>;
}